// @flow
const toInitials = function (initials: string) {
  if (initials !== '') {
    // Prep initials
    initials = initials.replace(/\./g, '').toLowerCase()

    // Make array of initials, 'Th' is counted as one initial
    let initialsArray = initials.match(/(th|[a-z])/g)

    if (initialsArray != null) {
      // Max 4 initialsArray
      if (initialsArray.length > 4) {
        initialsArray = initialsArray.slice(0, 4)
      }
      // Make initialsArray uppercase, in case of "Th" only the first char
      for (const [index, value] of initialsArray.entries()) {
        initialsArray[index] = value.substring(0, 1).toUpperCase() + value.substring(1)
      }

      // Place dots between the initials
      initials = initialsArray.join('.') + '.'
    }
  }

  return initials
}

const stripDigits = function (text: string) {
  return text.replace(/[0-9]/g, '')
}

export {
  toInitials,
  stripDigits
}



// WEBPACK FOOTER //
// ./src/utils/string.js